import makeStyles from '@mui/styles/makeStyles';
const autocompleteStyles = makeStyles(({ transitions, palette }) => ({
    fieldWrapper: {
        width: '100%',
    },
    root: {
        paddingRight: 12,
        margin: 0,
    },
    dealerContainer: {
        display: 'block',
    },
    dealerTitle: {},
    dealerInfo: {},
    dropdownIcon: {},
    dropdownIconOpened: {
        transform: 'rotate(180deg)',
    },
    input: {
        transition: transitions.create(['border-color', 'box-shadow']),
        '& input': {
            padding: 0,
            height: 'fit-content',
        },
    },
    errorText: {
        // TODO fix guidance linting error forbidden-style-keys
        // eslint-disable-next-line @dxp-module/guidance/forbidden-style-keys
        fontSize: 'inherit',
    },
    focused: {
        borderColor: palette.primary.main,
    },
    inputError: {
        borderColor: palette.error.main,
    },
    listbox: {
        padding: 0,
        position: 'absolute',
        zIndex: 10,
        width: '100%',
        overflow: 'auto',
    },
    noOptions: {},
    endInputAdornment: {
        position: 'absolute',
        right: 10,
    },
}), { name: 'Common_Autocomplete' });
export default autocompleteStyles;
//# sourceMappingURL=autocomplete.styles.js.map